import DispatchConstants from 'app/shared/constants/DispatchConstants';

const RentGuaranteeActions = {
    setMonthlyRent(monthlyRent) {
        return dispatch => dispatch({
            type: DispatchConstants.RENT_GUARANTEE_UPDATE_MONTHLY_RENT,
            payload: monthlyRent,
        });
    },
    setPaymentMethod(paymentMethod) {
        return dispatch => dispatch({
            type: DispatchConstants.RENT_GUARANTEE_UPDATE_PAYMENT_METHOD,
            payload: paymentMethod,
        });
    },
    setSecurityDepositAmount(securityDepositAmount) {
        return dispatch => dispatch({
            type: DispatchConstants.RENT_GUARANTEE_UPDATE_SECURITY_DEPOSIT_AMOUNT,
            payload: securityDepositAmount,
        });
    },
    setIsSecurityDepositRequired(isSecurityDepositRequired) {
        return dispatch => dispatch({
            type: DispatchConstants.RENT_GUARANTEE_UPDATE_IS_SECURITY_DEPOSIT_REQUIRED,
            payload: isSecurityDepositRequired,
        });
    },
    setTenantPaymentAmount(tenantPaymentAmount) {
        return dispatch => dispatch({
            type: DispatchConstants.RENT_GUARANTEE_UPDATE_TENANT_PAYMENT_AMOUNT,
            payload: tenantPaymentAmount,
        });
    },
    setLandlordReceiptAmount(landlordReceiptAmount) {
        return dispatch => dispatch({
            type: DispatchConstants.RENT_GUARANTEE_UPDATE_LANDLORD_RECRIPT_AMOUNT,
            payload: landlordReceiptAmount,
        });
    },
    setIsOnlineToolsEnabled(isOnlineToolsEnabled) {
        return dispatch => dispatch({
            type: DispatchConstants.RENT_GUARANTEE_UPDATE_IS_ONLINE_TOOLS_ENABLED,
            payload: isOnlineToolsEnabled,
        });
    },
};

export default RentGuaranteeActions;
